import common from '~~/i18n/locales/modules/common.json'
import home from '~~/i18n/locales/modules/home.json'
import pos from '~~/i18n/locales/modules/pos.json'
import menu from '~~/i18n/locales/modules/menu.json'
import stock from '~~/i18n/locales/modules/stock.json'
import expense from '~~/i18n/locales/modules/expense.json'
import reports from '~~/i18n/locales/modules/reports.json'
import settings from '~~/i18n/locales/modules/settings.json'
import topup from '~~/i18n/locales/modules/topup.json'
import owner from '~~/i18n/locales/modules/owner.json'
import owner_layout from '~~/i18n/locales/modules/owner-layout.json'
import login from '~~/i18n/locales/modules/login.json'
import register from '~~/i18n/locales/modules/register.json'
import layout from '~~/i18n/locales/modules/layout.json'
import runMode from '~~/i18n/locales/modules/runMode.json'
import lockScreen from '~~/i18n/locales/modules/lockScreen.json'
import openShop from '~~/i18n/locales/modules/openShop.json'
import closeShop from '~~/i18n/locales/modules/closeShop.json'
import accountExpired from '~~/i18n/locales/modules/accountExpired.json'
import expiryWarning from '~~/i18n/locales/modules/expiryWarning.json'

const modules = { common, home, pos, menu, stock, expense, reports, settings, topup, owner, owner_layout, login, register, layout, runMode, lockScreen, openShop, closeShop, accountExpired, expiryWarning }
const LOCALES = ['th', 'en'] as const

function pick(node: unknown, idx: number): unknown {
  if (Array.isArray(node)) return node[idx] ?? node[0] ?? ''
  if (node && typeof node === 'object') {
    const out: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(node as Record<string, unknown>))
      out[k] = pick(v, idx)
    return out
  }
  return node
}

// setLocaleMessage REPLACES the locale's messages wholesale, so this list — not
// i18n.config.ts's — is what the app actually reads. Adding a module to only one
// of the two silently drops it at runtime. Keep both in sync.
export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as any
  if (!i18n) return
  LOCALES.forEach((code, i) => {
    i18n.setLocaleMessage(code, pick(modules, i))
  })
})
